import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

type Mode = 'blue' | 'dark';

interface ModeContextProps {
    mode: Mode;
    toggleMode: (toggleFlag: boolean) => void;
}

const ModeContext = createContext<ModeContextProps | undefined>(undefined);

interface ModeProviderProps {
    children: ReactNode;
}

export const ModeProvider: React.FC<ModeProviderProps> = ({ children }) => {
    const storedMode = localStorage.getItem('mode');
    const initialMode: Mode = storedMode === 'dark' ? 'dark' : 'blue';
    const [mode, setMode] = useState<Mode>(initialMode);

    const toggleMode = (toggleFlag: boolean) => {
        if (!toggleFlag) return;
        const newMode = mode === 'blue' ? 'dark' : 'blue';
        setMode(newMode);
        localStorage.setItem('mode', newMode);
    };

    useEffect(() => {
        document.documentElement.classList.remove('blue', 'dark');
        document.documentElement.classList.add(mode);
    }, [mode]);

    return (
        <ModeContext.Provider value={{ mode, toggleMode }}>
            {children}
        </ModeContext.Provider>
    );
};

export const useMode = () => {
    const context = useContext(ModeContext);
    if (!context) {
        throw new Error('useMode must be used within a ModeProvider');
    }
    return context;
}